module.exports = __webpack_public_path__ + "static/img/guanwang22.a3ac597d.png";